import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import get from 'lodash/get';
import { stringify } from 'query-string';
import injectLoader from '@signal/hoc/injectLoader';
import { activeAccountIdSelector } from '@signal/core/auth';
import { syncActiveAccountLoader } from '@signal/core/user';
import { ACCOUNTS } from '@signal/routes';
import AuthenticatedRoute from '../AuthenticatedRoute';
/**
 * This component, wrapping the `AuthenticatedRoute` component, first requires
 * the user to be authenticated, and then adds an additional condition that an
 * active account is required to render the route. If no active account is found,
 * a redirect to the account selection page will happen (unless the user is
 * already on the account selection page).
 */

function ActiveAccountRequiredRoute(props) {
  var path = props.path,
      computedMatch = props.computedMatch;
  var activeAccountId = useSelector(activeAccountIdSelector);
  var _window$location = window.location,
      pathname = _window$location.pathname,
      search = _window$location.search;
  var qs = stringify({
    referrer: "".concat(pathname).concat(search)
  });
  /**
   * @returns {boolean} Returns true if there is an active account or the
   * current location is the account selection page.
   */

  var shouldRenderComponent = useMemo(function () {
    return Boolean(activeAccountId || path === ACCOUNTS.path || get(computedMatch, 'params.accountId') //  <-- this should be removed
    );
  }, [activeAccountId, computedMatch, path]);
  return /*#__PURE__*/React.createElement(AuthenticatedRoute, Object.assign({
    conditions: [{
      condition: shouldRenderComponent,
      redirectTo: {
        pathname: ACCOUNTS.path,
        search: qs
      }
    }]
  }, props));
}

export default injectLoader(syncActiveAccountLoader)(ActiveAccountRequiredRoute);